<template>
	<div class="w-full">
		<label class="block text-md lg:text-lg">
			{{ label }}
		</label>
		<select
			:value="modelValue"
			@input="$emit('update:model', $event.target.value)"
			class="block w-full lg:max-w-lg rounded-md py-1 px-2 h-9 lg:h-11 capitalize"
			:class="{
				[`bg-${bgColor}`]: !bgColor.startsWith('#'),
				[`bg-[${bgColor}]`]: bgColor.startsWith('#'),
			}"
		>
			<option
				value=""
			>
				{{ defaultOption }}
			</option>
			<option
				v-for="(option, index) in options"
				:key="index"
				:value="option"
				class="capitalize"
			>
				{{ option }}
			</option>
		</select>
	</div>
</template>

<script>
export default {
	name: 'SelectInput',
	props: {
		label: {
			type: String,
			default: 'Label',
		},
		modelValue: {
			type: String,
			default: '',
		},
		options: {
			type: Array,
			default: () => [],
		},
		defaultOption: {
			type: String,
			default: 'Select an option',
		},
		color: {
			type: String,
			default: 'primary-3',
		},
	},
	emits: [
		'update:model'
	],
	computed: {
		bgColor() {
			return this.color || 'primary-3';
		},
	},
};
</script>
